export function formatMoney(
  coins?: number,
  opts: { nullValue?: string; maxDigits?: number } = {},
) {
  const { nullValue = '$0' } = opts;
  if (coins == null) return nullValue;
  const value = coins / 100;
  return `$${value.toLocaleString('en-US', { maximumFractionDigits: opts.maxDigits ?? 2 })}`;
}
